import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('Values')
export class Values {
  @JsonProperty('id', String)
  public id?: string = undefined;
  @JsonProperty('values', [Object])
  public values?: any[] = undefined;
}
